import React from 'react';
// CSS 加载顺序固定：主题变量 → 奇门样式 → 八字样式 → MeiHua 适配层
// （八字页复用奇门的 .panel/.btn/.seg 等基础类，故两页都加载全部样式）
import '../features/theme.css';
import '../features/qimen/styles.css';
import '../features/bazi/bazi.css';
import '../features/adapt.css';
// 排盘逻辑与组件保持原样（与 Qi Men 仓库逐字节一致），此处仅接入 MeiHua 布局
import QimenFeature from '../features/qimen/QimenPage.jsx';

export const QimenPage: React.FC = () => (
  <div className="mh-scope mh-qimen">
    <QimenFeature />
  </div>
);
